import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "g-window" };
const _hoisted_2 = {
    key: 0,
    class: "window-header"
};
const _hoisted_3 = { class: "title" };
const _hoisted_4 = ["title", "aria-label"];
const _hoisted_5 = { class: "window-body" };
const _hoisted_6 = {
    key: 1,
    class: "window-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showHeader)
            ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                _renderSlot(_ctx.$slots, "modal-header", {}, () => [
                    _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    (_ctx.isClosable)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "close",
                            title: 'global.window.labelClose',
                            "aria-label": 'global.window.labelClose',
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.currentWindow.close && _ctx.currentWindow.close(...args)), ["prevent"]))
                        }, [
                            _createVNode(_component_g_icon, {
                                width: "16",
                                height: "16",
                                src: "/assets/icons/x-square.svg"
                            })
                        ], 8, _hoisted_4))
                        : _createCommentVNode("", true)
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
                class: _normalizeClass(_ctx.classContent)
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2)
        ]),
        (_ctx.hasFooterSlot)
            ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
                _renderSlot(_ctx.$slots, "modal-footer")
            ]))
            : _createCommentVNode("", true)
    ]));
}
